import { Wrapper, Main, Aside } from "./PlaylistFeatured.styled";
import Tile from "../Tile";

import SubHeader from "../SubHeader";

function PlaylistFeatured({ playlist, onGameClick, onMoreClick }) {
  const asideGames = playlist.games.slice(1);
  const mainGame = [playlist.games[0]];

  return (
    <>
      <SubHeader onMoreClick={onMoreClick}>{playlist.name}</SubHeader>
      <Wrapper>
        <Main>
          <Tile
            isFeatured
            onGameClick={onGameClick}
            key={mainGame[0]._id}
            game={mainGame[0]}
          />
        </Main>
        <Aside>
          {asideGames.map((asideGame) => (
            <Tile
              isFeatured
              onGameClick={onGameClick}
              key={asideGame._id}
              game={asideGame}
              isAside
            />
          ))}
        </Aside>
      </Wrapper>
    </>
  );
}

export default PlaylistFeatured;
